<template>
  <div id="app">
    <header>
      <div class="head-nav">
        <div class="head-logo">
          <div>
            <img src="./assets/img/schoollogo.png" alt="东大建筑新人赛">
            <span class="line"></span>
            <img style="width: 60px;" src="./assets/img/2024logo.png" alt="东大建筑新人赛">
          </div>
        </div>
        <div class="head-option">
          <div v-show="token == ''" class="nav-right">
            <div class="link_us"><a href="#/post">上传作品</a></div>
            <div class="link_us"><a @click="goAnchor('last')" href="javascript:void(0)">联系我们</a></div>
            <div class="personal_info">
              <a href="#/login" >登录</a>
              <span class="small_line"></span>
              <a href="#/regist" >注册</a>
            </div>
          </div>
          <div v-show="token != ''" class="nav-myinfo clearfix">
            <div class="link_us"><a href="#/post">上传作品</a></div>
            <div class="link_us"><a @click="goAnchor('last')" href="javascript:void(0)">联系我们</a></div>
            <div class="aboutme">
              <div>我的</div>
              <ul class="zh_myinfo">
                <li><a href="#/work" style="color:#7719bc">我的作品</a></li>
                <li><a href="#/user" style="color:#7719bc">资料与账号</a></li>
              </ul>
            </div>
            <div class="out"><a @click="logout()">退出</a></div>
          </div>
          <div class="category clearfix">
            <ul class="category-wrap clearfix">
              <li class="menu-item" @click="toMenu(menuItem.path, index)" v-for="(menuItem, index) in menus" :key="index">
                <router-link class="tab-item" :to="menuItem.path" :key="index">{{menuItem.name}}</router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
      
    </header>

    <div class="content-area middle-content">
      <router-view v-if="isRouterAlive" @token="changeToken" ></router-view>
    </div>
    <div id="last" class="footer" >
      <div class="link">
        <div class="link_div">主办单位: 东南大学建筑学院</div>
        <div class="link_div">官方邮箱: arch_newer@foxmail.com</div>
        <div class="link_div" style="margin-top: 40px; font-size: 12px">南京清晓信息科技有限公司 © 2024 <a href="https://beian.miit.gov.cn/" style="color:#FFFFFF">苏ICP备13063229号-4</a></div>
        <div class="ball_wrap">
            <div class="ball ball_wx"><div class="erweima erweima_status"></div></div>
        </div>
      </div>
      <div>
        <div style="font-family: sy; font-size: 12px; text-align: center; margin-top: 20px;"><a href="https://beian.miit.gov.cn/" target="_blank" style="color:#FFFFFF"></a>
        </div>
      </div>
    </div>
 
    <div class="huojian yincang">UP</div>
  </div>
</template>

<script>
import jquery from 'jquery'

export default {
  name: "app",
  data() {
    return {
      token: "",
      isRouterAlive: true,
      menus: [
        {
          name: "首页",
          path: "/home",
        },
        {
          name: "100强名单",
          path: "/top",
        },
//        {
//          name: "亚洲赛推荐奖作品展示",
//          path: "/recommend",
//        },
//        {
//          name: "104强工作营成果线上展",
//          path: "/exhibition",
//        },
        {
          name: "往届作品",
          path: "/entry",
        },
        {
          name: "大赛光影",
          path: "/interview",
        },
        {
          name: "常见问题",
          path: "/qa",
        }
      ]

     };
  },
  provide: function() {
    return {
      reload: this.reload
    };
  },
  mounted: function(){
    jquery("#animation_zh>li").mouseenter(function(){
      jquery(this).children("div").stop().animate({"width":"250px"})
      jquery(this).css("color","white")
      jquery(this).css("opacity",1)
    }).mouseleave(function(){
      jquery(this).children("div").stop().animate({"width":"0"})
      jquery(this).css("color","")
      jquery(this).css("opacity",0.8)
    })

    jquery(".aboutme").mouseenter(function(){
      jquery(".myinfo").slideDown(100)
      jquery(".zh_myinfo").slideDown(100)
    }).mouseleave(function(){
      jquery(".myinfo").slideUp(100)
      jquery(".zh_myinfo").slideUp(100)
    })

    jquery(document).scroll(function(){
      let scroH = jquery(document).scrollTop()
      let viewH = jquery(window).height()
      let contentH = jquery(document).height()
      if(scroH > 100){
        jquery(".huojian").stop().show()
      }else{
        jquery(".huojian").stop().hide()
      }

    })
    jquery(".huojian").click(function(){
      document.getElementsByTagName('html')[0].scrollTop = 0
    })


    jquery(".ball_wx").mouseenter(function(){
      jquery(".erweima").show()
    }).mouseleave(function(){
      jquery(".erweima").hide()
    })

    function checkIE(){
      return '-ms-scroll-limit' in document.documentElement.style && '-ms-ime-align' in document.documentElement.style
    }
    if (checkIE()) {
      window.addEventListener('hashchange', () => {
        var currentPath = window.location.hash.slice(1);
        if (this.$route.path !== currentPath) {
        this.$router.push(currentPath)
        }
      }, false)
    }
  },
  created: function() {
    this.load();
  },
  watch: {
    token: function(val) {
      let _t = this;
      _t.$ls.set("token", val);
    }
  },
  methods: {
    goAnchor (id) {
      document.getElementById(id).scrollIntoView();
    },
    load: function() {
      let _t = this;
      _t.token = _t.$ls.get("token", "");
    },
    changeToken: function(val) {
      let _t = this;
      _t.token = val;
    },
    logout: function() {
      let _t = this;
      _t.token = "";
      _t.$ls.remove("token");
      _t.$router.push("/");
      _t.reload();
    },
    reload: function() {
      this.isRouterAlive = false;
      this.$nextTick(function() {
        this.isRouterAlive = true;
      });
    },
    provide: function() {
      return {
        reload: this.reload
      };
    },
    toMenu: function(path, index) {
      this.$router.push(path)
    }
  }
};
</script>

<style>
@import "./assets/css/common.css";
@import "./common/iconfont/iconfont.css";

#app {
}
.huojian{
  position:fixed;
  bottom: 50px;
  right: 135px;
  width: 40px;
  height: 40px;
  line-height: 40px;
  background: #660874;
  border-radius: 4px;
  text-align: center;
  color: #fff;
  cursor: pointer;
}
.yincang{
  display: none;
}
.middle-content{
  min-height:600px;
}
.clearfix:after{
  content:"";
  display: table;
  clear:both;
}
.clearfix{
  *zoom: 1;
}
@font-face {
  font-family: sy;
  src: url("assets/font/SourceHanSansK-Regular.ttf");
}
@font-face {
  font-family: sybold;
  src: url("assets/font/SourceHanSansK-Bold.ttf");
}
@font-face {
  font-family: sylight;
  src: url("assets/font/SourceHanSansK-Light.ttf");
}
.el-alert {
  text-align: center;
  border-radius: inherit;
  font-size: 14px;
}
.el-alert a {
  padding-left: 10px;
  font-size: 14px;
  line-height: 18px;
  color: red;
}
.head-option{
  height: 120px;
  padding: 10px 0 20px 50px;
  display: flex;
  flex-direction: column;
  width: 800px;
}
.head-logo{
  padding: 43px 50px 0 20px;
  height: 120px;
}
.head-nav{
  height: 120px;
  background: #bc65d6;
  color:white;
  overflow:unset;
  padding: 0 calc((100% - 1024px) / 2);
  display: flex;
}
.line{
  margin:11px;
  display:inline-block;
  height:40px;
  vertical-align: top;
  width:0;
  border-left: 1px solid white;
}
.head-option .nav-right>ul>li{
}
.category-wrap{
  display: flex
}
.category-wrap>li{
  font-family: sybold;
  font-size: 14px;
  color: white;
  padding: 5px 10px;
  margin-left: 5px;
  margin-right: 30px;
}
.category-wrap>li:hover{
  color: #7719bc;
}
.category-wrap>li>a{
  color:inherit;
}
.category-nav{
  display: none;
}

.category-nav li>div{
  position: absolute;
  width: 0px;
  height:50px;
  border-top-right-radius: 25px;
  border-bottom-right-radius: 25px;
  background:#7719bc;

}
.category-nav li>a{
  position: relative;
  z-index: 2;
}
.category .clearfix{
  margin-top: 25px;
}
.nav-right{
  display: flex;
  justify-content: flex-end;
}
.link_us a,.personal_info a,.language{
  font-family: sy;
    font-size: 14px;
    color: #FFFFFF;
}
.personal_info,.small_line{
  line-height: 30px;
  display: inline;
}
.personal_info >a{
  display: inline;
}
.small_line{
  width:0;
  height:16px;
  border-left:1px solid #FFFFFF;
  margin: 7px 10px;
}
.link_us{
  margin-right: 30px;
  height:30px;
  line-height: 30px;
}
.language{
  margin-left:40px;
  margin-right:16px;
  height:30px;
  line-height: 30px;
}
.language:hover{
  cursor: pointer;
  color:#7719bc;
}
.aboutcompetion{
  position:relative;
  cursor: pointer;
}
.aboutcompetion ul{
  position: absolute;
  left:0;
  top: 40px;
  width: 225px;
  z-index: 9;
  border-radius: 4px;
}
.aboutcompetion ul li{
  position:relative;
  font-family: sybold;
  width: 100%;
  color: black;
  height: 50px;
  font-size: 17px;
  text-align: left;
  line-height: 50px;
  background: #ececec;
  opacity: 0.9;
}
.aboutcompetion ul li>a{
  color:inherit;
  padding-left: 11px;
}
.nav-right a:hover{
  color:#7719bc;
}
.nav-myinfo>div>a:hover{
  color:#7719bc;
}
/* 联系我们 */
.link{
    padding-top: 50px;
}
.link_div{
    text-align: center;
    font-size: 14px;
    color:#FFFFFF;
    font-family: sy;
}
.link_dom{
    text-align: center;
    font-size: 12px;
    color:#FFFFFF;
    font-family: sy;
    position: fixed;
    bottom: 10px;
}
.ball{
    float: left;
    width: 48px;
    height: 48px;
    border-radius: 15px;
    margin-left: 10px;
}
.ball_wx{
  position: absolute;
  top: -220px;
  left: -66px;;
  background: url(./assets/img/wx.png) no-repeat;
}
.ball_wx:hover{
  background: url(./assets/img/wx_l.png) no-repeat;
}
.erweima{
  width: 180px;
  height:210px;
  position: absolute;
  top: -220px;
  left: -66px;;
  background:url(./assets/img/erweima.png) no-repeat;
}
.erweima_status{
  display: none;
}
.footer{
  background: #bc65d6;
  margin-top:60px;
}
.link{
  width: 70%;
  margin: 0 auto;
  padding-top: 20px;
}
/* 我的 */
.nav-myinfo{
  display: flex;
  margin-right: 26px;
  font-size: 14px;
  justify-content: flex-end;
}
.myinfo{
  display: none;
  position:relative;
  height:60px;
}
.zh_myinfo{
  display: none;
  position:relative;
  height:60px;
}
.myinfo li{
  font-family: sylight;
  font-size: 17px;
  text-align: left;
  padding-left: 10px;
  height: 30px;
  line-height: 30px;
  width: 80px;
  position: absolute;
}
.myinfo li:nth-child(1){
  top:0px;
}
.myinfo li:nth-child(2){
  top:30px;
}
.zh_myinfo li{
  font-family: sylight;
  font-size: 14px;
  text-align: left;
  padding-left: 10px;
  height: 30px;
  line-height: 30px;
  width: 80px;
  position: absolute;
}
.zh_myinfo li:nth-child(1){
  top:0px;
}
.zh_myinfo li:nth-child(2){
  top:30px;
}
.myinfo li:hover{
  background: #7719bc;
  color:white;
}
.zh_myinfo li:hover{
  background: #FFFFFF;
  color:white;
}
.myinfo li>a{
}
.nav-myinfo>div{
  height:30px;
  line-height: 30px;
  text-align: left;
  font-family: sylight;
  font-size: 14px;
  color: #FFFFFF;
}
.nav-myinfo>div:hover{
  color:#7719bc;
  cursor: pointer;
}
.aboutme {
  width: 60px;
}
.out a{
  color:inherit;
}
.nav-myinfo>div.out{
  width: 80px;
}
.nav-myinfo>div.En{
  width:60px;
}
h3 {
  font-size: 24px;
}
.content-area {
}
.router-link-active {
  color: #7719bc !important;
}
</style>




// WEBPACK FOOTER //
// App.vue?d11ada8c